import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { fetchList } from "../api";
import { PageHero, Loader } from "../components/Shared";

export default function Gallery() {
  const [items, setItems] = useState(null);
  const [active, setActive] = useState(null);
  useEffect(() => { fetchList("gallery").then(setItems).catch(() => setItems([])); }, []);
  if (!items) return <Loader />;

  return (
    <div data-testid="gallery-page">
      <PageHero kicker="Ringside View" title="Gallery" image="https://images.unsplash.com/photo-1546711076-85a7923432ab?crop=entropy&cs=srgb&fm=jpg&q=85&w=2000" />
      <section className="px-6 md:px-12 lg:px-20 pb-24">
        <div className="columns-1 sm:columns-2 lg:columns-3 gap-4 space-y-4">
          {items.map((g, i) => (
            <motion.button key={g.id} data-testid={`gallery-item-${g.id}`} onClick={() => setActive(g)} initial={{ opacity: 0 }} whileInView={{ opacity: 1 }} viewport={{ once: true }} transition={{ delay: (i % 6) * 0.05 }}
              className="relative group block w-full break-inside-avoid overflow-hidden border border-zinc-800">
              <img src={g.image} alt={g.caption} className="w-full object-cover group-hover:scale-105 transition-transform duration-500" />
              <div className="absolute inset-0 bg-gradient-to-t from-[#050505]/90 to-transparent opacity-0 group-hover:opacity-100 transition-opacity flex items-end p-4">
                <div className="text-left">
                  <p className="font-display text-xl uppercase leading-none">{g.caption}</p>
                  <p className="text-brand text-xs font-mono uppercase tracking-widest mt-1">{g.event}</p>
                </div>
              </div>
            </motion.button>
          ))}
        </div>
        {items.length === 0 && <p className="text-zinc-500">No photos yet.</p>}
      </section>

      {active && (
        <div data-testid="gallery-lightbox" onClick={() => setActive(null)} className="fixed inset-0 z-[110] bg-black/95 flex items-center justify-center p-6 cursor-zoom-out">
          <div className="max-w-5xl">
            <img src={active.image} alt={active.caption} className="max-h-[80vh] w-auto mx-auto" />
            <div className="text-center mt-4">
              <p className="font-display text-2xl uppercase">{active.caption}</p>
              <p className="text-brand font-mono text-xs uppercase tracking-widest mt-1">{active.event}</p>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
